export const getFullDay = (day: string): string => {
  switch (day) {
    case 'Пн.':
      return 'Понедельник';
    case 'Вт.':
      return 'Вторник';
    case 'Ср.':
      return 'Среда';
    case 'Чт.':
      return 'Четверг';
    case 'Пт.':
      return 'Пятница';
    case 'Сб.':
      return 'Суббота';
    case 'Вс.':
      return 'Воскресенье';
  }
  return '';
}
